import { nodeListToArray } from './nodelist-to-array'
import { removeElements } from './remove-elements'

declare const TNEW_RESOURCES_DOMAIN;

function xhrRequest(url: string, requestType: string, successFunction?: Function, errorFunction?: Function) {
    let xhttp = new XMLHttpRequest();
    xhttp.withCredentials = true;
    xhttp.onreadystatechange = () => {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
            //success!
            if (successFunction) {
                if (requestType === "POST")
                    successFunction(xhttp.responseURL);
                else
                    successFunction(xhttp.responseText); 
            }
        }
        else {
            if (errorFunction) {
                errorFunction();
            }
        }
    };
    xhttp.open(requestType, url, true);
    if (requestType === "POST")
        xhttp.setRequestHeader('Content-Type', 'text/html'); 
    else
        xhttp.setRequestHeader('accept', 'application/json'); 
    xhttp.send(); 
} 

export function loginState() {
    let loginStateRequestSuccess = function (responseText) {
        let isLoggedIn = JSON.parse(responseText);
        let loggedOutLinks = nodeListToArray<HTMLElement>(document.querySelectorAll('.utility-nav-loggedout-js'));
        let loggedInLinks = nodeListToArray<HTMLElement>(document.querySelectorAll('.utility-nav-loggedin-js'));
        let linksToHide = loggedInLinks;
        //Testing purposes only! isLoggedIn = true;
        if (isLoggedIn) {
            linksToHide = loggedOutLinks;
        }
        removeElements(linksToHide);
    }
    xhrRequest(TNEW_RESOURCES_DOMAIN + '/api/login/IsLoggedIn', "GET", loginStateRequestSuccess);
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/login-state.ts